import { Link } from "react-router-dom";
import { Button } from "./ui/button";

const SECTIONS = ["what_changed", "needs_attention", "can_wait", "source_issues_confidence"];
const SECTION_KEYS = {
  what_changed: "ws.ai.what_changed",
  needs_attention: "ws.ai.attention",
  can_wait: "ws.ai.can_wait",
  source_issues_confidence: "ws.ai.confidence",
};

export function AiSummaryCard({ summary, changes, canWrite, busy, onGenerate, t }) {
  const refLink = (ref) => {
    if (!changes) return null;
    const i = ref.indexOf(":");
    const kind = ref.slice(0, i);
    const rid = ref.slice(i + 1);
    if (kind === "alert") {
      const a = (changes.items || []).find((x) => x.alert_id === rid);
      return a ? `/dzialka/${a.parcel_id.replaceAll("/", "~")}` : null;
    }
    if (kind === "src" || kind === "stale") {
      const all = [...(changes.source_issues || []), ...(changes.review_needed || [])];
      const x = all.find((q) => q.pp_id === rid);
      return x ? `/dzialka/${x.parcel_id.replaceAll("/", "~")}` : null;
    }
    if (kind === "report") return `/raport/${rid}`;
    return null;
  };
  const current = Boolean(changes && summary && summary.content_hash === changes.content_hash);
  return (
    <section data-testid="ai-summary-section" className="mt-6 rounded-xl border border-slate-200 bg-white p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-[11px] font-bold uppercase tracking-widest text-slate-400">{t("ws.ai.title")}</h2>
        {canWrite && (
          <Button data-testid="ai-summary-generate" size="sm" variant="outline" onClick={onGenerate} disabled={busy}>
            {t("ws.ai.generate")}
          </Button>
        )}
      </div>
      {!summary && <p data-testid="ai-summary-none" className="mt-2 text-xs text-slate-500">{t("ws.ai.empty")}</p>}
      {summary && (
        <div className="mt-3">
          <p className="text-[10px] text-slate-400">
            {t("ws.ai.hash")}: <span data-testid="ai-summary-hash" className="font-mono">{summary.content_hash.slice(0, 16)}…</span>
            {" · "}<span data-testid="ai-summary-currency" className={current ? "text-emerald-700" : "text-amber-700"}>{current ? t("ws.ai.current") : t("ws.ai.stale")}</span>
            {summary.cached && <> · {t("ws.ai.cached")}</>}
            {summary.dropped_statements > 0 && <> · {t("ws.ai.dropped")}: <span data-testid="ai-summary-dropped">{summary.dropped_statements}</span></>}
          </p>
          {summary.insufficient_evidence ? (
            <p data-testid="ai-summary-insufficient" className="mt-2 rounded-md bg-amber-50 px-3 py-2 text-xs text-amber-800">
              {t("ws.ai.insufficient")} {summary.insufficient_reason || ""}
            </p>
          ) : (
            SECTIONS.map((s) => (
              <div key={s} data-testid={`ai-section-${s}`} className="mt-3">
                <h3 className="text-[10px] font-bold uppercase tracking-wider text-slate-500">{t(SECTION_KEYS[s])}</h3>
                {(summary.summary[s] || []).length === 0 && <p className="mt-1 text-xs text-slate-400">{t("ws.ai.empty")}</p>}
                <ul className="mt-1 space-y-1">
                  {(summary.summary[s] || []).map((item, i) => (
                    <li key={i} data-testid={`ai-statement-${s}-${i}`} className="text-xs text-slate-700">
                      {item.statement}
                      <span className="ml-1 inline-flex flex-wrap gap-1">
                        {item.refs.map((ref) => {
                          const href = refLink(ref);
                          const label = `${ref.split(":")[0]}:${ref.slice(ref.indexOf(":") + 1).slice(0, 6)}`;
                          const chip = <span className="rounded bg-slate-100 px-1 font-mono text-[9px] text-slate-500">{label}</span>;
                          return href
                            ? <Link key={ref} data-testid={`ai-ref-${ref.replace(":", "-")}`} to={href} className="hover:underline">{chip}</Link>
                            : <span key={ref} data-testid={`ai-ref-${ref.replace(":", "-")}`}>{chip}</span>;
                        })}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))
          )}
          <p data-testid="ai-summary-disclaimer" className="mt-3 border-t border-slate-100 pt-2 text-[10px] text-slate-400">{t("ws.ai.disclaimer")}</p>
        </div>
      )}
    </section>
  );
}
